import * as actions from './actionTypes'


export const cookiedEnabledAction = (flag) => ({
  type: actions.COOKIES_ENABLED,
  payload: {
    description: flag,
  },
})

export const screenLoadingAction = () => ({
  type: actions.SCREEN_LOADING,
})

export const addressUpdateAction = (value) => ({
  type: actions.ADDRESS_UPDATE,
  payload: {
    description: value,
  },
})

export const renewalPeriodAction = (period, amount, extraFees = []) => ({
  type: actions.RENEWAL_PERIOD,
  payload: {
    period,
    amount,
    extraFees
  },
})

export const masterNumberAction = (value) => ({
  type: actions.MASTER_NUMBER,
  payload: {
    description: value,
  },
})

export const plateNumberAction = (value) => ({
  type: actions.PLATE_NUMBER,
  payload: {
    description: value,
  },
})

export const vinSerialNumberAction = (value) => ({
  type: actions.VIN_SERIAL_NUMBER,
  payload: {
    description: value,
  },
})

export const vehicleTypeAction = (value) => ({
  type: actions.VEHICLE_TYPE,
  payload: {
    description: value,
  },
})

export const insuranceCompanyAction = (value) => ({
  type: actions.INSURANCE_COMPANY,
  payload: {
    description: value,
  },
})

export const policyNumberAction = (value) => ({
  type: actions.POLICY_NUMBER,
  payload: {
    description: value,
  },
})

export const effectiveDateAction = (value) => ({
  type: actions.EFFECTIVE_DATE,
  payload: {
    description: value,
  },
})

export const expiryDateAction = (value) => ({
  type: actions.EXPIRY_DATE,
  payload: {
    description: value,
  },
})

export const commercialAquacultureAction = (value) => ({
  type: actions.COMMERCIAL_AQUACULTURE,
  payload: {
    description: value,
  },
})

export const fishingVesselAction = (value) => ({
  type: actions.FISHING_VESSEL,
  payload: {
    description: value,
  },
})

export const fullNameAction = (value) => ({
  type: actions.FULL_NAME,
  payload: {
    description: value,
  },
})

export const emailAddressAction = (value) => ({
  type: actions.EMAIL_ADDRESS,
  payload: {
    description: value,
  },
})

export const confirmEmailAddressAction = (value) => ({
  type: actions.CONFIRM_EMAIL_ADDRESS,
  payload: {
    description: value,
  },
})

export const phoneNumberAction = (value) => ({
  type: actions.PHONE_NUMBER,
  payload: {
    description: value,
  },
})

export const editPlateNumberAction = (value) => ({
  type: actions.EDIT_PLATE_NUMBER,
  payload: {
    plateNumber: value,
  },
})

export const addRenewalPeriodsAction = (data) => ({
  type: actions.ADD_RENEWAL_PERIODS,
  payload: data,
})

export const addPermitAction = (data) => ({
  type: actions.ADD_PERMIT,
  payload: {
    plateNumber: data.plateNumber,
    vinSerialNumber: data.vinSerialNumber,
    insuranceCompany: data.insuranceCompany,
    policyNumber: data.policyNumber,
    effectiveDate: data.effectiveDate,
    expiryDate: data.expiryDate,
    renewalPeriod: data.renewalPeriod,
    renewalAmount: data.renewalAmount,
    extraFees: data.extraFees,
    vehicleClass: data.vehicleClass,
    vehicleFuelType: data.vehicleFuelType,
    vehicleType: data.vehicleType,
    commercialAquaculture: data.commercialAquaculture,
    fishingVessel: data.fishingVessel,
    insurancePosition: data.insurancePosition
  },
})

export const editPermitAction = (data) => ({
  type: actions.EDIT_PERMIT,
  payload: {
    plateNumber: data.plateNumber,
    vinSerialNumber: data.vinSerialNumber,
    insuranceCompany: data.insuranceCompany,
    policyNumber: data.policyNumber,
    effectiveDate: data.effectiveDate,
    expiryDate: data.expiryDate,
    renewalPeriod: data.renewalPeriod,
    renewalAmount: data.renewalAmount,
    extraFees: data.extraFees,
    vehicleClass: data.vehicleClass,
    vehicleFuelType: data.vehicleFuelType,
    vehicleType: data.vehicleType,
    commercialAquaculture: data.commercialAquaculture,
    fishingVessel: data.fishingVessel,
    insurancePosition: data.insurancePosition
  },
})

export const deletePermitAction = (plateNumber) => ({
  type: actions.DELETE_PERMIT,
  payload: {
    plateNumber: plateNumber,
  },
})

export const editFromConfirmationAction = (flag) => ({
  type: actions.EDIT_FROM_CONFIRMATION,
  payload: {
    description: flag,
  },
})

export const clearInsuranceInfoAction = () => ({
  type: actions.CLEAR_INSURANCE_INFO_ACTION
})

export const clearPermitAction = () => ({
  type: actions.CLEAR_PERMIT_INFO,
})

export const clearAllUserDataAction = () => ({
  type: actions.CLEAR_ALL_USER_DATA,
})

export const clearAllAction = () => ({
  type: actions.CLEAR_ALL,
})
